import { Flex } from '@components/gassan-ui'
import { useTranslation } from 'next-i18next'
import { rem } from 'polished'
import { FC } from 'react'
import styled from 'styled-components'

const Logo = styled.img`
  height: ${rem(21)};
  width: auto;
`

const Logos: FC = () => {
  const {
    i18n: { language },
  } = useTranslation()
  return (
    <Flex justifyContent="space-between">
      <Logo src="/images/american_express.svg" alt="American Express" />
      {language !== 'de' && <Logo src="/images/ideal.svg" alt="iDeal" />}
      <Logo src="/images/mastercard.svg" alt="Mastercard" />
      <Logo src="/images/visa.svg" alt="Visa" />
      <Logo src="/images/bancontact.svg" alt="Bancontact" />
      <Logo src="/images/paypal.svg" alt="Paypal" />
    </Flex>
  )
}

export default Logos
